// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bcs_a"};